import Glide from "@glidejs/glide";
import "@glidejs/glide/dist/css/glide.core.min.css";

(($) => {
  $(document).ready(function () {
    const $header = $("#header");
    if ($header.length) {
      if ($header.hasClass("header--home")) {
        let ticking = false;
        const onScroll = () => {
          $header.toggleClass("header--scrolled", window.scrollY > 50);
          ticking = false;
        };
        window.addEventListener(
          "scroll",
          () => {
            if (!ticking) {
              window.requestAnimationFrame(onScroll);
              ticking = true;
            }
          },
          { passive: true },
        );
        onScroll();
      }
      const $burger = $header.find(".header__burger");
      const closeMenu = () => {
        $header.removeClass("menu-open");
        $("body").removeClass("menu-open");
        $burger.attr("aria-expanded", "false");
      };
      $burger.on("click", function () {
        const open = !$header.hasClass("menu-open");
        $header.toggleClass("menu-open", open);
        $("body").toggleClass("menu-open", open);
        $(this).attr("aria-expanded", open ? "true" : "false");
      });
      $header
        .find(
          ".header__item:not(.has-sub) > .header__link, .header__sublink, .header__cta",
        )
        .on("click", closeMenu);
      $header
        .find(".header__item.has-sub > .header__link")
        .on("click", function (e) {
          if (window.matchMedia("(max-width: 1279.98px)").matches) {
            e.preventDefault();
            $(this).closest(".header__item").toggleClass("open");
          }
        });
    }
    $(".footer__top").on("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
    $(".cd-modal-trigger").click(function (e) {
      e.preventDefault();
      openModal($(this).find(".modal--content").html());
    });
    $(".modal--bg, #modal .close").click(function () {
      closeModal();
    });
    function openModal(c) {
      $("#modal").find(".container").append(c);
      $(".modal--container").addClass("show");
      $("html, body").addClass("overflow-hidden");
    }
    function closeModal() {
      $(".modal--container").removeClass("show");
      $("html, body").removeClass("overflow-hidden");
      setTimeout(function () {
        $("#modal").find(".container").empty();
      }, 300);
    }
    $(".lightgallery")
      .lightGallery({ download: false, selector: "a" })
      .on("onBeforeSlide.lg", function () {
        $(".lg-backdrop").css("opacity", "0.8");
        $(".lg-sub-html").css("opacity", "0");
      });
    if ($(".glide").length > 0) {
      $(".glide").each(function () {
        if (
          $(this).closest(".pillars__glide, .offers__glide, .references__glide")
            .length
        )
          return;
        new Glide(this, {
          type: "carousel",
          perView: 3.02,
          touchAngle: 0,
          breakpoints: {
            1103: {
              touchAngle: 45,
              autoplay: 4000,
              perView: 2.02,
              focusAt: "center",
            },
            506: {
              touchAngle: 45,
              autoplay: 4000,
              perView: 1.03,
              focusAt: "center",
              peek: { before: 20, after: 20 },
            },
          },
        }).mount();
      });
    }
  });
})(jQuery);
